import styled from 'styled-components';
import { typography, spacing } from '../../style/theme';
var H1 = styled.h1.withConfig({
  displayName: "H1",
  componentId: "w0wxvc-0"
})(["text-align:center;@media only screen and (max-width:", "px){font-size:", "rem;line-height:3rem;}"], spacing.collapseMenuWidth, typography.large);
export default H1;